const styles = {
  scrReaderOnly: "sr-only",
  toggleBtnContainer:
    "text-sm md:text-base flex flex-wrap gap-2 text-white items-center cursor-pointer",
  toggleBtn:
    "inline-flex items-center p-2 text-gray-700 rounded-full bg-gray-200 focus:outline-none",
  toggleIcon: "w-6 h-6 duration-150",
  onIconClick: "hidden",
  darkMode: "dark:text-white text-black",
  lightMode: "text-white",
  themeLabel: "lg:hidden text-base font-semibold",
};
export default styles;
